import { render, staticRenderFns } from "./mobileHeadView.vue?vue&type=template&id=1fd5bdca&scoped=true"
import script from "./mobileHeadView.vue?vue&type=script&lang=js"
export * from "./mobileHeadView.vue?vue&type=script&lang=js"
import style0 from "./mobileHeadView.vue?vue&type=style&index=0&id=1fd5bdca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5bdca",
  null
  
)

export default component.exports